// v2.13.1 Operational Reminders — etiquetas de lectura. NO recalcula nada: los slots, los estados,
// la anticipación y la zona horaria los resuelve el backend. La hora se muestra tal como la programó
// el sitio (`slot_local`, hora de pared) y NUNCA se reinterpreta con la timezone del navegador.
export const DIAS = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

export const FRECUENCIAS = [
  { value: "unica", label: "Una vez" },
  { value: "diaria", label: "Todos los días" },
  { value: "semanal", label: "Días específicos" },
];

export const ESTADO_OCURRENCIA = {
  programada: { label: "Programada", tono: "text-slate-500 bg-slate-50 border-slate-200" },
  pendiente: { label: "En Central", tono: "text-[#012472] bg-[#01CBE3]/10 border-[#01CBE3]/40" },
  vencida: { label: "En Central · vencida", tono: "text-amber-700 bg-amber-50 border-amber-200" },
  completada: { label: "Recordatorio comunicado", tono: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  no_realizada: { label: "Sin contacto", tono: "text-rose-700 bg-rose-50 border-rose-200" },
  anulada: { label: "Anulada", tono: "text-slate-400 bg-slate-50 border-slate-200" },
  no_entregada: { label: "No entregada por el sistema", tono: "text-slate-500 bg-slate-100 border-slate-200" },
};

export const ESTADO_TAREA = {
  activa: "Activo", pausada: "Pausado", cancelada: "Cancelado", finalizada: "Finalizado",
};

export function resumenRegla(regla) {
  if (!regla) return "—";
  const horas = (regla.horas || []).join(" · ");
  if (regla.tipo === "unica") return `Una vez · ${regla.fecha} · ${horas}`;
  const fin = regla.fin?.fecha_limite
    ? ` · hasta ${regla.fin.fecha_limite}`
    : regla.fin?.max_ocurrencias
      ? ` · ${regla.fin.max_ocurrencias} veces`
      : "";
  const desde = regla.desde ? ` · desde ${regla.desde}` : "";
  if (regla.tipo === "diaria") return `Todos los días · ${horas}${desde}${fin}`;
  const dias = (regla.dias || []).map((d) => DIAS[d]).join(", ");
  return `${dias} · ${horas}${desde}${fin}`;
}

export function avisoTexto(min) {
  const n = Number(min || 0);
  return n > 0 ? `avisa ${n} min antes` : "avisa a la hora exacta";
}

// slot_local llega como "AAAA-MM-DDTHH:MM" (hora de pared del sitio, sin offset): se parte, no se
// convierte con Date, para no desplazarla con la zona del navegador.
export function slotTexto(slot) {
  if (!slot) return "—";
  const [f, h] = String(slot).split("T");
  return `${f} · ${h}`;
}
